// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const enumToArray = (e: any, keyType: 'string' | 'number' = 'number') => {
  let keys: (string | number)[] = Object.keys(e);
  if (keyType === 'number') {
    keys = keys.filter(k => parseInt(String(k), 10) >= 0);
    keys = keys.map(k => Number(k));
  }

  const array = keys.map(k => ({
    key: k,
    value: e[k]
  }));

  return array;
};
